import { CheckCircle2, HeartHandshake } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { SITE } from "@/lib/site";

const points = [
  "Semakan kelayakan pinjaman secara percuma & tanpa komitmen",
  "Bimbingan dokumen lengkap sebelum dihantar ke bank",
  "Kemas kini status permohonan anda dari semasa ke semasa",
  "Nasihat jujur mengenai pilihan bank & pakej terbaik",
];

export default function About() {
  return (
    <section id="profil" data-testid="about-section" className="py-24 md:py-32 bg-white">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-14 items-center">
          <Reveal>
            <div className="relative">
              <img
                src={SITE.images.house}
                alt="Rumah moden di Malaysia"
                className="w-full h-[420px] object-cover rounded-3xl border border-slate-200"
                loading="lazy"
              />
              <div className="absolute -bottom-6 -right-4 md:right-6 rounded-2xl bg-[#0A2540] text-white px-6 py-5 shadow-xl max-w-[220px]">
                <HeartHandshake className="h-6 w-6 text-[#F59E0B]" />
                <p className="mt-2 font-heading font-bold leading-tight">
                  Dedikasi penuh untuk impian rumah anda
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <span className="text-sm font-semibold uppercase tracking-wider text-[#1D4ED8]">
              Profil Profesional
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A2540]">
              Rakan yang anda boleh percaya untuk urusan pinjaman rumah
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              Sebagai {SITE.role} di bawah <strong>{SITE.agency}</strong>, saya{" "}
              <strong>{SITE.agentName}</strong> komited membantu setiap pelanggan
              melalui proses permohonan pinjaman perumahan dengan mudah dan tenang.
              Kerahsiaan maklumat anda adalah keutamaan saya — setiap dokumen
              dikendalikan dengan penuh amanah dan hanya digunakan untuk tujuan
              permohonan pinjaman anda.
            </p>
            <ul className="mt-8 space-y-4">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#10B981]" />
                  <span className="text-slate-700">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
